// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function Conversation__ConversationsSection__SendMessageButtons$SendPublicMessageButton(props) {
  var onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: (function (param) {
                  onSubmit();
                }),
              disabled: props.submitDisabled,
              children: "Send a new public message"
            });
}

var SendPublicMessageButton = {
  make: Conversation__ConversationsSection__SendMessageButtons$SendPublicMessageButton
};

function Conversation__ConversationsSection__SendMessageButtons$SendPrivateMessageButton(props) {
  var onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: (function (param) {
                  onSubmit();
                }),
              disabled: props.submitDisabled,
              children: "Send private message"
            });
}

var SendPrivateMessageButton = {
  make: Conversation__ConversationsSection__SendMessageButtons$SendPrivateMessageButton
};

var Buttons;

exports.Buttons = Buttons;
exports.SendPublicMessageButton = SendPublicMessageButton;
exports.SendPrivateMessageButton = SendPrivateMessageButton;
/* ButtonsV5 Not a pure module */
